document.addEventListener('turbolinks:load', () => {
  // サイドバー内のドロップダウンリストの開閉
  $('#setting_dropdown_toggle').on('click', function() {
    $('li.js-setting-dropdown-menu').slideToggle(100);
  })
});
